import { render, staticRenderFns } from "./WInlineText.vue?vue&type=template&id=274af42b&scoped=true&"
import script from "./WInlineText.vue?vue&type=script&lang=js&"
export * from "./WInlineText.vue?vue&type=script&lang=js&"
import style0 from "./WInlineText.vue?vue&type=style&index=0&id=274af42b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274af42b",
  null
  
)

export default component.exports